export default {
    // 頁面標題
    PvPTFgameTitle: "火箭升空-是非題遊戲設定",
    
    // 設置區域
    topicLabel: "主題",
    inputTopic: "請輸入主題",
    questionLabel: "題目",
    inputQuestion: "請輸入題目",
    addQuestion: "新增題目",
    correctAnswer: "正確",
    wrongAnswer: "錯誤",
    gameDuration: "遊戲時長",
    second: "秒",
    saveSettings: "儲存設置",
    answerMode: "作答模式",
    syncMode: "同步跳題",
    individualMode: "各自進度跳題(做答完直接跳下一題)",
    
    // 提示訊息
    maxQuestions: "最多只能有20個題目",
    questionExists: "題目已存在",
    errorItems:"錯誤題目",
    correctItems:"正確題目",
    
    // 按鈕文字
    addQuestionButton: "新增題目",
    saveSettingsButton: "儲存設置",

    startGame: "開始遊戲",
    pauseGame: "暫停遊戲",
    resumeGame: "繼續遊戲",
    gameOver: "遊戲結束",
    leftSide: "左方",
    rightSide: "右方",
    leftWins: "左方獲勝！",
    rightWins: "右方獲勝！",
    tie: "平局！",
    topic: "主題",
    
    // 遊戲結束畫面新增字串
    win: "勝利",
    items: "個",
    wrongItems: "答對題目",
    maxCombo: "最高連擊",
    showAnswers: "A",
    gamePaused: "活動暫停",
    referenceAnswers: "參考答案",
    answered: "已作答",
    clearData: "清空設定",
    answerTime: "作答時間",
    sendSuccess: "遊戲資料已成功推送！",
    sendCooldown: "已按過送出，請等候1分鐘才可再操作",
    pushSuccess: "遊戲已成功推送到 HiTeach！",
    pushFailed: "推送失敗：{message}",
    tokenRefreshing: "正在刷新授權資訊，請稍後再試...",
    configLoadSuccess: "成功載入遊戲設定",
    configLoadFailed: "載入失敗（將使用範例設定）",

    // 小螢幕警告
    smallScreenWarning: "本遊戲為桌面版介面，建議於電腦平板使用，且最低螢幕寬度需求為 1200px*800px",
    currentRank: "目前排名",
    totalParticipants: "總參與人次",
}
